<div *ngIf="show" [ngClass]="{
  'toast-success': type === 'success',
  'toast-error': type === 'error'
}" class="{{classToast}} d-flex justify-content-center align-items-center p-12">
    <i *ngIf="type === 'success'" class="icon-check toast-icon-success"></i>
    <i *ngIf="type === 'error'" class="icon-cross toast-icon-error"></i>
    <em (click)="closeToast()" class="icon-cross toast-icon-close" type="button"></em>
    <p [innerHTML]="title" class="ml-4 mb-0"></p>
</div>
